export default __webpack_public_path__ + "static/media/file-blank.7cb0324a.svg";